import Api from 'services/api';
import { PROTOCOL, PAUL_DOMAIN } from 'constants';
export const updateStatus = (request_id, new_status_id) => {
  return new Promise((resolve, reject) => {
    Api.post('/status_updates', {
      request_id,
      new_status_id,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getRequests = (page = 1, expand = [], filters = {}) => {
  return new Promise((resolve, reject) => {
    Api.get('/requests', {
      params: {
        expand,
        page,

        ...filters,
      },
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getRequest = (requestId) => {
  return new Promise((resolve, reject) => {
    Api.get(`/requests/${requestId}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getRequestDocuments = (requestId, include_archived = false) => {
  return new Promise((resolve, reject) => {
    Api.get(`/requests/${requestId}/documents`, {
      params: { include_archived },
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getRequestDocumentsFromPaul = (requestId, include_archived = false, currentBrand) => {
  return new Promise((resolve, reject) => {
    Api.get(`/requests/${requestId}/documents`, {
      baseURL: `${PROTOCOL}://${PAUL_DOMAIN}`,
      params: { include_archived },
      headers: { 'x-brand': currentBrand?.slug },
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getRequestViews = (requestId) => {
  return new Promise((resolve, reject) => {
    Api.get(`/requests/${requestId}/views`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const createRequest = (workflowId, groupId, seller_manager_id, invisible) => {
  return new Promise((resolve, reject) => {
    Api.post('/requests', {
      request: {
        workflow_id: workflowId,
        group_id: groupId,
        seller_manager_id,
        invisible,
      },
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const addRequestUpload = (requestId, signed_id, block_id) => {
  return new Promise((resolve, reject) => {
    Api.post(`/requests/${requestId}/uploads`, {
      upload: {
        block_id,
        file: signed_id,
      },
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteRequestUpload = (requestId, upload_id) => {
  return new Promise((resolve, reject) => {
    Api.delete(`/requests/${requestId}/uploads/${upload_id}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteRequestEnrichedUpload = (requestId, upload_id) => {
  return new Promise((resolve, reject) => {
    Api.delete(`/requests/${requestId}/enriched_uploads/${upload_id}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getRequestNotes = (requestId) => {
  return new Promise((resolve, reject) => {
    Api.get(`/requests/${requestId}/notes`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const createRequestNote = (requestId, note) => {
  return new Promise((resolve, reject) => {
    Api.post(`/requests/${requestId}/notes`, {
      note,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateRequestNote = (requestId, note) => {
  return new Promise((resolve, reject) => {
    Api.put(`/requests/${requestId}/notes/${note.id}`, {
      note,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteRequestNote = (requestId, noteId) => {
  return new Promise((resolve, reject) => {
    Api.delete(`/requests/${requestId}/notes/${noteId}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getRequestMessages = (requestId) => {
  return new Promise((resolve, reject) => {
    Api.get(`/requests/${requestId}/messages`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const createRequestMessage = (requestId, message) => {
  return new Promise((resolve, reject) => {
    Api.post(`/requests/${requestId}/messages`, {
      message,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const closeRequestMessaging = (requestId) => {
  return new Promise((resolve, reject) => {
    Api.put(`/requests/${requestId}/messaging`, {
      request: {
        messaging_status: 'closed',
      },
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const createRequestAnonymousToken = (requestId) => {
  return new Promise((resolve, reject) => {
    Api.post(`/requests/${requestId}/anonymous_user_tokens`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const archiveRequest = (requestId) => {
  return new Promise((resolve, reject) => {
    Api.post(`/requests/${requestId}/archive`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const unarchiveRequest = (requestId) => {
  return new Promise((resolve, reject) => {
    Api.post(`/requests/${requestId}/unarchive`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const duplicateProviderRequest = (requestId, superAdmin = false, options) => {
  return new Promise((resolve, reject) => {
    let params = {
      super_admin: superAdmin,
      ...(options && {
        clean_data: options.cleanData,
        reset_status: options.resetStatus,
        invisible: options.invisible,
      }),
    };
    Api.post(`/requests/${requestId}/duplicate`, params)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const duplicateRequest = (requestId, superAdmin = false) => {
  return new Promise((resolve, reject) => {
    Api.post(`/requests/${requestId}/duplicate`, { super_admin: superAdmin })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getGeneratedEmails = (requestId) => {
  return new Promise((resolve, reject) => {
    Api.get(`/requests/${requestId}/generated_emails`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const getRequestFilter = () => {
  return new Promise((resolve, reject) => {
    Api.get(`/request_filters`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
